import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import type { IconProps } from '@avodah-inc/types';
import { cn } from '@avodah-inc/ui/utils';

const notificationBellVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type NotificationBellProps = React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof notificationBellVariants> &
  IconProps;

export const NotificationBell = React.forwardRef<
  SVGSVGElement,
  NotificationBellProps
>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          notificationBellVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox}
        width={width}
        {...props}
      >
        <path d="M12.4498 16.002C12.335 16.5671 12.0284 17.0752 11.5819 17.4402C11.1354 17.8051 10.5764 18.0045 9.99977 18.0045C9.42309 18.0045 8.86414 17.8051 8.41764 17.4402C7.97113 17.0752 7.66452 16.5671 7.54977 16.002H12.4498ZM9.99777 2C13.1468 2 15.7418 4.335 15.9818 7.355L15.9948 7.578L15.9998 7.802L15.9988 11.408L16.9528 13.995L16.9778 14.08L16.9938 14.166L16.9988 14.255C16.9988 14.57 16.8028 14.845 16.4768 14.962L16.3628 14.995L16.2488 15.005H3.75077C3.66234 15.0047 3.57465 14.9888 3.49177 14.958C3.20477 14.853 3.01577 14.586 3.00977 14.242L3.01377 14.125L3.04777 13.995L3.99777 11.411L3.99977 7.793L4.00377 7.568C4.12677 4.451 6.77077 2 9.99777 2Z" />
      </svg>
    );
  },
);

NotificationBell.displayName = 'NotificationBell';
